import { useEffect, useState } from 'react';
import CardComponent from '../../../../components/base/CardComponent';
import MonthlyStepper from '../../../../components/monthly_stepper/MonthlyStepper';


import { Calendar } from '../../../../util/calendar';
import { EmployeePensionOffset } from '../types';
import { IDatasource } from '../../../../components/monthly_stepper/types';
import { useTranslation } from 'react-i18next';
import { getEmployeePensionOffset } from '../../../../api/service/company/employees/employee-pension-offset.service';

const HEADER_COLUMNS = [
  { title: 'Reported pension', name: 'pensionOffset' },
  { title: 'Reported salary changes', name: 'salaryChange' },
];

interface Props {
  employeeID: string;
}

const PensionOffset = ({ employeeID }: Props) => {
  const [pensionOffsetSource, setPensionOffsetSource] = useState<IDatasource>({
    headers: [...HEADER_COLUMNS],
    reports: [],
  });

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const fetchEmployeeYearlyPensionOffset = async (yearRange: [string, string] | null = null) => {
    const _yearRange = yearRange || Calendar.getLastNumberMonthsBoundary(6);
    try {
      setLoading(true);

      let pensionOffsetResult: EmployeePensionOffset[] = await getEmployeePensionOffset(employeeID, {
        duration: { from: _yearRange[0], to: _yearRange[1] },
      });

      //const pensionOffsetDataset = fillMissingMonthsAndYears(pensionOffsetResult, YEAR_BOUNDARY[0], YEAR_BOUNDARY[1]);
      const _pensionOffsetSource = {
        ...pensionOffsetSource,
        reports: toPensionOffsetModel(pensionOffsetResult)
      };
      setPensionOffsetSource(_pensionOffsetSource);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const toPensionOffsetModel = (pensionOffsetDataset: EmployeePensionOffset[] = []) => {
    return pensionOffsetDataset.map((yearlyPensionOffset) => {
      const dataset = HEADER_COLUMNS.map((column) => {
        return {
          name: column.name,
          months: yearlyPensionOffset.offsets.map((monthlyOffset) => {
            return {
              monthIndex: monthlyOffset.month,
              value: monthlyOffset[column.name],
            };
          }),
        };
      });

      return {
        year: yearlyPensionOffset.year,
        dataset,
      };
    });
  };

  const handlePrevious = (range: [string, string]) => {
    setTimeout(() => fetchEmployeeYearlyPensionOffset(range), 0);
  };

  const handleNext = (range: [string, string]) => {
    setTimeout(() => fetchEmployeeYearlyPensionOffset(range), 0);
  };

  useEffect(() => {
    fetchEmployeeYearlyPensionOffset();
  }, []);
  

  return (
    <>
      <CardComponent>
        <MonthlyStepper
          headerTitle={t('pension_company')}
          datasource={pensionOffsetSource}
          loading={loading}
          onNextMonth={handleNext}
          onPreviousMonth={handlePrevious}
        />
      </CardComponent>
    </>
  );
};

export default PensionOffset;
